// Import firebase
import { firebaseAuth, propertiesModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
import { GenerateUID } from '@/mixins/helpers/GenerateUID'
import { InvoiceEventsRepository } from '@/repositories/invoice-events/InvoiceEventsRepository'

export const UpdateOpenInvoice = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        GenerateUID,
        InvoiceEventsRepository

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        error: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        updateOpenInvoiceHandler: function() {

            /*
            **  Update the invoice to open
            **  @method: @here
            */

            try {

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).update({
                    'attributes.description': this.invoice.attributes.description,
                    'attributes.status': this.invoice.attributes.status,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {
    
                    /* 
                    ** Set the new invoice event
                    ** @method: @here
                    */
                    
                    if (!this.error) this.setInvoiceEventData();
    
                })
                .then(() => {
    
                    /* 
                    **  Create an invoice event for the update
                    **  @location: @here
                    */
    
                    if (!this.error) this.createInvoiceEvent();
    
                })
                .then(() => {
    
                    /* 
                    ** Finish the update
                    ** @method: @here
                    */
    
                    if (!this.error) this.finishUpdate();
    
                })
                .then(() => {
    
                    /* 
                    ** If error, handle it
                    ** @method: @here
                    */
    
                    if (this.error) this.handleError();
    
                })
                .catch(error => {
    
                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                   
                    this.reportAuthBugsnagError({
                        title: 'Update Invoice Status to Open in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'iOScD5zsJHDTJwaiJahF',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating the Invoice Status to Open.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'BDZ4LmdBN27wGRf5iUzN',
                    error: e
                });

            }

        },

        handleError: function() {

            try {

                /* 
                ** Close the modal
                ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
                */

                this.closeTheModal();

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display error message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Uh Oh!', 'We ran into a problem trying to update the invoice.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Handle the Error When Updating the Invoice Status to Open.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'L5NIGpJxaD1qgQk0AakE',
                    error: e
                });

            }

        },

        setInvoiceEventData: function() {

            /*
            **  Set the invoice event data
            **  @location: Repositories/InvoiceEvents
            */

            try {

                this.new_invoice_event.id = this.generateUID();
                this.new_invoice_event.type = 'invoice.update';
                this.new_invoice_event.attributes.title = 'The invoice was updated on ' + moment().format() + '.';
                this.new_invoice_event.attributes.application = 'Nestd | Web';
                this.new_invoice_event.attributes.source = 'Nestd - ' + firebaseAuth.currentUser.displayName;
                this.new_invoice_event.attributes.request = {
                    status: this.invoice.attributes.status,
                    description: this.invoice.attributes.description
                };
                this.new_invoice_event.attributes.response = this.invoice;
                this.new_invoice_event.relationships.company = this.invoice.relationships.company;
                this.new_invoice_event.relationships.resident = this.invoice.relationships.resident;
                this.new_invoice_event.relationships.invoice = this.invoice.id;
                this.new_invoice_event.relationships.unit = this.invoice.relationships.unit;
                this.new_invoice_event.relationships.property = this.invoice.relationships.property;
                this.new_invoice_event.relationships.lease = this.invoice.relationships.lease;
                this.new_invoice_event.relationships.rent = this.invoice.relationships.rent;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Setting the invoice event data when updating invoice to open status.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'bVJvZCU4CRdzeUFFHRun',
                    error: e
                });

            }

        },

        createInvoiceEvent: function() {

            try {

                /* 
                ** Create an invoice event
                ** @location: Repositories/Invoices/InvoiceEventsRepository
                */

                propertiesModel.doc(this.invoice.relationships.property).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).collection('events').doc(this.new_invoice_event.id).set(this.new_invoice_event)
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Create New Invoice Event in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'r893rX4pg45U6yb85DCw',
                        error: error
                    });

                });

                /* 
                ** Create a resident event
                ** @location: Repositories/Invoices/InvoiceEventsRepository
                */

                propertiesModel.doc(this.invoice.relationships.property).collection('residents').doc(this.invoice.relationships.resident).collection('events').doc(this.new_invoice_event.id).set(this.new_invoice_event)
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Create New Resident Event in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'ujypKaejPU7GOmtJWBNC',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Creating a New Invoice Event.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'BNDzerNwSpzfzEr2HSkH',
                    error: error
                });

            }

        },

        finishUpdate: function() {

            try {

                /* 
                ** Emit the refresh invoice event
                ** @service: @Vue
                */

                this.$emit('refreshInvoice', this.invoice);

                /* 
                ** Close the modal
                ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
                */

                this.closeTheModal();

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display success message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Success!', 'Your rent invoice has been updated.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Finish Up the Open Invoice Update.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'EphPK4XziwYMAC7Nu8qr',
                    error: e
                });

            }

        }

    }

}